import { createContext } from 'react';

export type HistoryEntry = {
  pathname: string;
  search?: string;
};

export type NavigationHistoryContextType = {
  stack: HistoryEntry[];
};

export const NavigationHistoryContext =
  createContext<NavigationHistoryContextType>({
    stack: [],
  });
